export const actionTypes = {
  GET_INGESTION_MONITOR: "GET_INGESTION_MONITOR",
  SET_INGESTION_MONITOR: "SET_INGESTION_MONITOR",

  RESEND_CUSTOMERS_TO_SAP: "RESEND_CUSTOMERS_TO_SAP",
  SET_RESEND_CUSTOMERS_TO_SAP: "SET_RESEND_CUSTOMERS_TO_SAP",

  GET_RESEND_CUSTOMER_DATA: "GET_RESEND_CUSTOMER_DATA",
  SET_RESEND_CUSTOMER_DATA: "SET_RESEND_CUSTOMER_DATA",

  GET_ALL_INGESTIONS: "GET_ALL_INGESTIONS",
  SET_ALL_INGESTIONS: "SET_ALL_INGESTIONS",

  CANCEL_RESEND: "CANCEL_RESEND",
  SET_CANCEL_RESEND: "SET_CANCEL_RESEND",
};

export const actions = {
  getIngestionMonitor: (payload) => ({
    type: actionTypes.GET_INGESTION_MONITOR,
    payload: payload,
  }),

  setIngestionMonitor: (payload) => ({
    type: actionTypes.SET_INGESTION_MONITOR,
    payload: payload,
  }),

  resendCustomers: (payload) => ({
    type: actionTypes.RESEND_CUSTOMERS_TO_SAP,
    payload: payload,
  }),

  setResendCustomers: (payload) => ({
    type: actionTypes.SET_RESEND_CUSTOMERS_TO_SAP,
    payload: payload,
  }),

  getAllIngestions: (payload) => ({
    type: actionTypes.GET_ALL_INGESTIONS,
    payload: payload,
  }),

  setAllIngestions: (payload) => ({
    type: actionTypes.SET_ALL_INGESTIONS,
    payload: payload,
  }),

  getResendCustomerData: (payload) => ({
    type: actionTypes.GET_RESEND_CUSTOMER_DATA,
    payload: payload,
  }),

  setResendCustomerData: (payload) => ({
    type: actionTypes.SET_RESEND_CUSTOMER_DATA,
    payload: payload,
  }),

  cancelResend: (payload) => ({
    type: actionTypes.CANCEL_RESEND,
    payload: payload,
  }),

  setCancelResend: (payload) => ({
    type: actionTypes.SET_CANCEL_RESEND,
    payload: payload,
  }),
};
